// tslint:disable
export var ContactInfoPurposeType;
(function (ContactInfoPurposeType) {
    // UNKN
    ContactInfoPurposeType[ContactInfoPurposeType["UNKNOWN"] = 0] = "UNKNOWN";
    // MAIN
    ContactInfoPurposeType[ContactInfoPurposeType["MAIN"] = 1] = "MAIN";
    // MKTG
    ContactInfoPurposeType[ContactInfoPurposeType["MARKETING"] = 2] = "MARKETING";
    // SALES
    ContactInfoPurposeType[ContactInfoPurposeType["SALES"] = 3] = "SALES";
    // CUSTSER
    ContactInfoPurposeType[ContactInfoPurposeType["CUSTOMERSERVICE"] = 4] = "CUSTOMERSERVICE";
    // HOME
    ContactInfoPurposeType[ContactInfoPurposeType["HOME"] = 5] = "HOME";
    // WORK
    ContactInfoPurposeType[ContactInfoPurposeType["WORK"] = 6] = "WORK";
    // SEAS
    ContactInfoPurposeType[ContactInfoPurposeType["SEASONAL"] = 7] = "SEASONAL";
    // OTHR
    ContactInfoPurposeType[ContactInfoPurposeType["OTHER"] = 8] = "OTHER";
})(ContactInfoPurposeType || (ContactInfoPurposeType = {}));
//# sourceMappingURL=ContactInfoPurposeType.js.map